/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_TitleInputs */

const cs_draft_title = /** @type {(inputs: Draft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pole k tomuto inzerátu`)
};

const en_draft_title = /** @type {(inputs: Draft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fields for this listing`)
};

/**
* | output |
* | --- |
* | "Fields for this listing" |
*
* @param {Draft_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_title = /** @type {((inputs?: Draft_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_title(inputs)
	return cs_draft_title(inputs)
});